import { nanoid } from 'nanoid';
import { Node } from 'slate';

import {
  ELEMENT_OUTLINE_PARAGRAPH,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA_BULLET_LIST,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER_TITLE,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA_LIST_ITEM,
  ELEMENT_OUTLINE_PARAGRAPH_IDEA_TITLE,
  ELEMENT_OUTLINE_PARAGRAPH_TITLE,
} from './OutlineParagraphPlugin.types';

function createOutlineParagraphIdeaListItemNode() {
  return {
    type: ELEMENT_OUTLINE_PARAGRAPH_IDEA_LIST_ITEM,
    id: nanoid(),
    children: [{ text: '' }],
  };
}

function createOutlineParagraphIdeaTitleNode() {
  return {
    type: ELEMENT_OUTLINE_PARAGRAPH_IDEA_TITLE,
    id: nanoid(),
    children: [{ text: '' }],
  };
}

function createOutlineParagraphIdeaBulletListNode() {
  return {
    type: ELEMENT_OUTLINE_PARAGRAPH_IDEA_BULLET_LIST,
    id: nanoid(),
    children: [createOutlineParagraphIdeaListItemNode()],
  };
}

function createOutlineParagraphIdeaNode() {
  return {
    id: nanoid(),
    type: ELEMENT_OUTLINE_PARAGRAPH_IDEA,
    children: [createOutlineParagraphIdeaTitleNode(), createOutlineParagraphIdeaBulletListNode()],
  } as Node;
}

function createOutlineParagraphTitleNode({ text = '' }) {
  return {
    id: nanoid(),
    type: ELEMENT_OUTLINE_PARAGRAPH_TITLE,
    children: [{ text }],
  };
}

function createOutlineParagraphContainerTitleNode() {
  return {
    id: nanoid(),
    type: ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER_TITLE,
    children: [{ text: '' }],
  };
}

function createOutlineParagraphNode({ title = 'Body Paragraph 1:' }) {
  return {
    id: nanoid(),
    type: ELEMENT_OUTLINE_PARAGRAPH,
    children: [
      createOutlineParagraphTitleNode({ text: title }),
      createOutlineParagraphContainerTitleNode(),
      {
        id: nanoid(),
        type: ELEMENT_OUTLINE_PARAGRAPH_IDEA_CONTAINER,
        children: [createOutlineParagraphIdeaNode(), createOutlineParagraphIdeaNode()],
      },
    ],
  } as Node;
}

export const outlineParagraphTransforms = {
  createOutlineParagraphNode,
  createOutlineParagraphIdeaNode,
  createOutlineParagraphTitleNode,
  createOutlineParagraphContainerTitleNode,
  createOutlineParagraphIdeaListItemNode,
  createOutlineParagraphIdeaTitleNode,
  createOutlineParagraphIdeaBulletListNode,
};
